import styled from 'styled-components';
import { tablet768, desktop1024 } from '@nubank/nuds-web/styles/breakpoints';

import Section from 'components/structure/Section';

const FullWidthSection = styled(Section)`
  & > * {
    max-width: none;

    ${tablet768`
      flex-flow: row nowrap;
    `}
  }

  ${desktop1024`
    max-height: 100vh;
  `}
`;

FullWidthSection.displayName = 'FullWidthSection';

export default FullWidthSection;
